<template>
    <div>
      <!-- <div class="listTitle" v-if="title != ''">
        <p><img src="../images/home/icon_1.png" alt="">
        {{title}}</p>
        <router-link class="moreBtn" :to="{path:titleHref}">更多<img src="../images/home/more.png" alt=""></router-link>
      </div> -->
        <ul class="designList">
            <li v-for="(item,index) in list" v-if="index < listLength" @click="goPageBtn(item)">
                <div class="listBg">
                    <div class="designImg"><img :src="item.icon" alt=""></div>
                    <div class="designName">{{item.name}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props:{
            list:{
                type: Array,
                default: ()=>{},
            },
            listLength:{
                type: Number,
                default: 12,
            },
            title:{
                type: String,
                default: '',
            },
            titleHref:{
                type: String,
                default: '',
            },
        },
        methods:{
            // 跳转详情
            goPageBtn(e){
                console.log(this.titleHref)
                this.$router.push(`${this.titleHref}/${e.id}`)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .designList{
        display: flex;
        flex-wrap: wrap;
        overflow: inherit;
        margin:0 -10px;
        li{
            padding:0 10px;
            margin-bottom:30px;
            width:(100%/4);
            overflow: inherit;
            .listBg{
                padding:20px;
                cursor: pointer;
                overflow: hidden;
                transition:all 0.3s;
                @include h-radius(5px);
                @include h-bgColor(var(--colorFF));
                &:hover{
                    margin:-5px 0 5px;
                    box-shadow: 0 0 20px rgba(0,0,0,0.15);
                }
            }
            .designImg{
                margin:0 auto;
                width:100%;
                height:153px;
                img{
                    object-fit: cover;
                    height: 100%;
                }
            }
            .designName{
                margin-top:6px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                @include h-fontSize(var(--color22),15px,28px);
            }
        }
    }

</style>